<template>
    <section id="touch_flex">
        <header>
            <div class="header__wrapper">
                <div class="header--text">
                    <h1>Loxone Configurator</h1>
                    <div class="header__button--wrapper">
                        <a v-if="$store.state.loggedIn" @click="loadConfiguration()" class="btn btn--ghost btn--white">{{$t('load_configuration')}}</a>
                        <a @click="buildNew()" class="btn btn--ghost btn--white">{{$t('start_from_scratch')}}</a>
                    </div>
                </div>
            </div>
        </header>
        <section v-if="Object.values(user_configurations).length > 0" class="configuration__list--wrapper light-grey">
            <div class="configuration__list--header">
                <div class="wrapper">
                    <h3>{{$t('my_touch_flex_configurations')}}</h3>
                </div>
            </div>
            <div class="configuration__list--content">
                <div class="wrapper">
                    <configuration-list :visibleEntries="12" :configurations="user_configurations" :opacityHandler="true"></configuration-list>
                </div>
            </div>
        </section>
        <section class="configuration__list--wrapper shark-anthracite" id="configuration__list--loxone">
            <div class="configuration__list--header">
                <div class="wrapper">
                    <h3>{{$t('loxone_templates')}}</h3>
                    <h4>{{$t('loxone_templates_info')}}</h4>
                </div>
            </div>
            <div class="configuration__list--content">
                <div class="wrapper">
                    <configuration-list :visibleEntries="6" :configurations="loxone_configurations"></configuration-list>
                </div>
            </div>
        </section>
        <section class="configuration__list--wrapper" id="configuration__list--templates">
            <div class="configuration__list--header">
                <div class="wrapper">
                    <h3>{{$t('start_from_scratch')}}</h3>
                    <h4>{{$t('start_from_scratch_info')}}</h4>
                </div>
            </div>
            <div class="configuration__list--content">
                <div class="wrapper">
                    <configuration-list :visibleEntries="visibleTemplates" :key="visibleTemplates" :configurations="templates"></configuration-list>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
    import axios from 'axios';
    import ConfigurationList from '../components/ConfigurationList.vue';
    export default {
        name: 'Home',
        components: {
            ConfigurationList
        },
        data() {
            return {
                visibleTemplates: 6,
                user_configurations: {},
                loxone_configurations: {},
                templates: {},
            }
        },
        methods: {
            loadConfiguration() {
                console.log('load configuration');
                this.$store.state.loadConfigurationOverlayVisible = true;
            },
            loxoneTemplates() {
                setTimeout(() => {
                    const id = 'configuration__list--loxone';
                    const yOffset = -115; 
                    const element = document.getElementById(id);
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

                    window.scrollTo({top: y, behavior: 'smooth'});
                }, 100);
            },
            buildNew() {
                this.visibleTemplates = 999;

                setTimeout(() => {
                    const id = 'configuration__list--templates';
                    const yOffset = -115; 
                    const element = document.getElementById(id);
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

                    window.scrollTo({top: y, behavior: 'smooth'});
                }, 100);



            }
        },
        created() {
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://configurator.loxone.com/api/loadAccountConfigurations',
            })
            .then(resp => {
                if (resp.data) {
                    this.user_configurations = resp.data;
                }
            });

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://configurator.loxone.com/api/loadLoxoneConfigurations',
            })
            .then(resp => {
                if (resp.data) {
                    this.loxone_configurations = resp.data;
                }
            });

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://configurator.loxone.com/api/loadTemplates',
            })
            .then(resp => {
                console.log(resp.data);
                if (resp.data) {
                    this.templates = resp.data;
                }
            });
        },
        watch: {
            '$store.state.flexSearchTerm': function() {
                for (const [key, value] of Object.entries(this.user_configurations)) {
                    value.hidden = false;
                    if(this.$store.state.flexSearchTerm.lentgh == 0) {
                        value.hidden = false;
                    } else if(value.description && value.description.toLowerCase().includes(this.$store.state.flexSearchTerm.toLowerCase())) {
                        value.hidden = false;
                    } else if(value.id.includes(this.$store.state.flexSearchTerm.toUpperCase())) {
                        value.hidden = false;
                    } else if(value.sku.toString().includes(this.$store.state.flexSearchTerm.toLowerCase())) {
                        value.hidden = false;
                    } else {
                        value.hidden = true;
                    }
                }

                
            },
        }
    }
</script>

<style lang="scss">
.configuration__list--wrapper{
        &.shark-anthracite{
            background-color: #575C61;

            h3, h4{
                color: #FFFFFF !important;
            }
        }

        &.light-grey{
            background-color: #E2E2E2;
        }

        .configuration__list--header{
            padding: 40px 0;
        }
        .configuration__list--content{
            padding: 0 0 40px 0;
        }

        h3{
            text-align: center;
            font-size: 50px;
            line-height: 55px;
            font-family: 'averta-extrabold', Arial, Helvetica, sans-serif;
        }

        h4{
            text-align: center;
            font-size: 21px;
            margin-top: 10px;
            line-height: 22px;

        }
    }
    </style>

<style lang="scss" scoped>
    header{
        text-align: center;
        //background-image: url("../assets/images/header_flex.png");
            background-image: url("../assets/images/header_flex_4.jpg");
        background-size: cover;
        background-position: center center;

        h1{
            margin-bottom: 20px;
        }

        .header__wrapper{
            max-width: 1040px;
            padding: 80px 20px;
            margin: 0 auto;
            align-items: center;
            justify-content: space-between;

            .header__button--wrapper{
                .btn{
                    margin: 0 15px;
                }
            }
        }
    }

    @media screen and (min-width: 420px) {
        header{
            background-image: url("../assets/images/header_flex_3.jpg") !important;

            .header__wrapper{
                padding: 40px 20px;
            }
        }
        //
    }

    @media screen and (min-width: 1340px) {
        header{
            background-image: url("../assets/images/header_flex_2.jpg") !important;

            .header__wrapper{
                padding: 80px 20px;
            }
        }
        //
    }

    @media screen and (max-width: 1920px) {
        header{
            background-image: url("../assets/images/header_flex.png") !important;
        }
    }
</style>